import { useTranslations } from '@/hooks/useTranslations';
import { type BreadcrumbItem } from '@/types';

type BreadcrumbPage = 'companies' | 'people' | 'leads' | 'projects' | 'work-orders' | 'employees';

export function useBreadcrumbs(page: BreadcrumbPage): BreadcrumbItem[] {
    const { t } = useTranslations();

    const breadcrumbs: Record<BreadcrumbPage, BreadcrumbItem[]> = {
        companies: [
            {
                title: t('companies.index.breadcrumbs.companies', 'Companies'),
                href: '/companies',
            },
        ],
        people: [
            {
                title: t('people.index.breadcrumbs.contacts', 'Contacts'),
                href: '/people',
            },
        ],
        leads: [
            {
                title: t('leads.index.breadcrumbs.leads', 'Leads'),
                href: '/leads',
            },
        ],
        projects: [
            {
                title: t('projects.index.breadcrumbs.projects', 'Projects'),
                href: '/projects',
            },
        ],
        'work-orders': [
            {
                title: t('work_orders.index.breadcrumbs.work_orders', 'Work Orders'),
                href: '/work-orders',
            },
        ],
        employees: [
            {
                title: t('employees.index.breadcrumbs.employees', 'Employees'),
                href: '/employees',
            },
        ],
    };

    return breadcrumbs[page] || [];
}
